import React from 'react';
import Container from '../../../containers/user/accounts/showUserContainer';

export default function () {
  return (
    <Container />
  );
}
